
export function useCheckin() {
  const checkin = []
  const isCheckingIn = false
  return { checkin, isCheckingIn };
}
